"use client";

import { ChevronRight } from "lucide-react";
import { authLinks } from "@/config/nav-links";
import { cn } from "@/lib/utils";
import { useNavThemeStyles } from "./nav-theme-context";
import { NavAvatarButton, useNavProfile } from "./nav-profile";
import TrackedLink from "./TrackedLink";

const primaryClassName =
    "bg-cta-primary text-cta-primary-text hover:bg-cta-primary-hover hover:text-cta-primary-text-hover";

const NavigationAuthButtons = () => {
    const theme = useNavThemeStyles();
    const { isAuthenticated, isAuthFetched } = useNavProfile();

    if (!isAuthFetched) {
        return null;
    }

    if (isAuthenticated) {
        return <NavAvatarButton />;
    }

    return (
        <div className="hidden items-center justify-end gap-4 sm:flex sm:flex-row-reverse">
            {authLinks.map((link, index) => {
                const isPrimary = index === 0;
                return (
                    <TrackedLink
                        key={link.href}
                        href={link.href}
                        event={link.eventName}
                        className={cn(
                            "inline-flex h-10 items-center justify-center gap-2 rounded-[var(--radius-m)] px-4 py-2 text-sm font-medium leading-5 no-underline transition-colors",
                            isPrimary ? primaryClassName : theme.secondaryCta,
                        )}
                    >
                        {link.label}
                        <ChevronRight className="size-4 shrink-0" aria-hidden />
                    </TrackedLink>
                );
            })}
            {/* <button
                type="button"
                className={cn("inline-flex size-6 items-center justify-center", theme.search)}
                aria-label="Search"
            >
                <Search className="size-6" strokeWidth={1.5} aria-hidden />
            </button> */}
        </div>
    );
};

export default NavigationAuthButtons;
